(function () {
  'use strict';

  angular.module('app').component('providerContactDetail', providerContactDetail());

  function providerContactDetail() {
    return {
      bindings: {
        item: '=',
        provider: '=',
        mode: '<',
        fast: '<',
        onProviderContactSaved: '&',
        onProviderContactCanceled: '&',
      },
      controller: ProviderContactDetailComponent,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/providers/provider-contacts/provider-contact-detail/provider-contact-detail.component.html',
    };
  }

  ProviderContactDetailComponent.$inject = ['UtilService', 'ProviderContactService'];

  function ProviderContactDetailComponent(UtilService, ProviderContactService) {
    var vm = this;

    vm.UtilService = new UtilService(vm);

    var fieldsDefinition = [
      'name',
      'last_name',
      'position',
      'email',
      'phone_number',
      'phone_extension',
      'mobile_number',
    ];

    // Methods
    vm.editProviderContact = editProviderContact;
    vm.saveProviderContact = saveProviderContact;
    vm.cancel = cancel;

    vm.$onInit = function () {
      if (vm.item.id) {
        // Edit
        setItemOptions(vm.item, vm.mode);
      } else {
        vm.createMode = true;
      }
    };

    function setItemOptions(item, mode) {
      vm.createMode = false;
      vm.editMode = false;
      vm.viewMode = true;

      if (mode === 'edit') {
        editProviderContact();
      }

      vm.originalItem = angular.copy(item);
    }

    function editProviderContact() {
      vm.editMode = true;
      vm.viewMode = false;
    }

    // Create/Update
    function saveProviderContact(isFormValid) {
      vm.formErrors = false;

      if (!isFormValid) {
        vm.serverErrors = [];
        vm.formErrors = true;

        return;
      }

      if (vm.UtilService.isFormDataChanged(vm.item, vm.originalItem, fieldsDefinition)) {
        vm.sendingForm = true;
        ProviderContactService.saveProviderContact(vm.item, vm.provider.id).then(function (data) {
          var status = data.status;
          var response = data.response;

          if (status) {
            // Success
            vm.onProviderContactSaved({ item: response });
          } else {
            vm.serverErrors = vm.UtilService._showItemServerErrors(response.errors);
            vm.formErrors = true;
          }

          vm.sendingForm = false;
        });
      } else {
        cancel();
      }
    }

    function cancel() {
      vm.onProviderContactCanceled();
    }
  }
})();
